module.exports = __webpack_public_path__ + "6685e7b5566bb3938e9edb3f26b31ca8.svg";